module.exports = __webpack_public_path__ + "img/1.ec70c651.jpg";